import Vue from 'vue';

export default {
    // Busca todos os itens cadastrados
    listarTodos() {
        return Vue.prototype.$http.get('/item');
    },

    // Busca detalhes de um item específico
    buscarPorId(id) {
        return Vue.prototype.$http.get(`/item/${id}`);
    },

    // Cadastra um novo item
    cadastrar(item) {
        return Vue.prototype.$http.post('/item', item);
    },

    // Atualiza um item existente
    atualizar(id, item) {
        return Vue.prototype.$http.put(`/item/${id}`, item);
    },

    // Altera o status de ativação do item
    alterarStatus(id, status) {
        return Vue.prototype.$http.put(`/item/${id}/status`, { status });
    },

    // // Deleta um item
    // deletar(id) {
    //     return Vue.prototype.$http.delete(`/item/${id}`);
    // }
};

